import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const BridgesList = ({ bridges, handleEditModalOpen, handleViewModalOpen, antipassbackEnabled, onAntipassbackChange }) => {
  const { t } = useTranslation('admin', { keyPrefix: 'bridges' });

  if (!bridges || bridges.length === 0) {
    return <p style={{ padding: '20px', textAlign: 'center' }}>No hay bridges disponibles.</p>;
  }

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('name')}</TableCell>
              <TableCell>{t('serial_number')}</TableCell>
              <TableCell>{t('created_at')}</TableCell>
              <TableCell>{t('updated_at')}</TableCell>
              <TableCell>{t('actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bridges.map(bridge => (
              <TableRow key={bridge.bridge_id}>
                <TableCell>{bridge.name}</TableCell>
                <TableCell>{bridge.serial_number}</TableCell>
                <TableCell>{new Date(bridge.created_at).toLocaleString()}</TableCell>
                <TableCell>{bridge.updated_at ? new Date(bridge.updated_at).toLocaleString() : t('no_doors')}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleViewModalOpen(bridge.bridge_id)}>
                    <VisibilityIcon titleAccess={t('view')} />
                  </IconButton>
                  <IconButton onClick={() => handleEditModalOpen(bridge.bridge_id)}>
                    <EditIcon titleAccess={t('edit')} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ alignItems: 'center', display: 'flex', mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={antipassbackEnabled}
              disabled={!antipassbackEnabled && !canEnableAntipassback(bridges)}
              onChange={onAntipassbackChange}
            />
          }
          label={t('antiPassback')}
        />
        <Tooltip title={t('antipassbackDescription')}>
          <IconButton size="small">
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

const canEnableAntipassback = bridges => {
  if (!bridges || bridges.length === 0) return false;

  // Check if there's at least one entry door and one exit door across all bridges
  let hasEntry = false;
  let hasExit = false;

  bridges.forEach(bridge => {
    if (bridge.doors) {
      if (bridge.doors.some(door => door.active && door.type === 'E')) {
        hasEntry = true;
      }
      if (bridge.doors.some(door => door.active && door.type === 'S')) {
        hasExit = true;
      }
    }
  });

  return hasEntry && hasExit;
};

export default BridgesList;
